"use strict";
var ESTransport = (function () {
    function ESTransport() {
    }
    return ESTransport;
}());
exports.ESTransport = ESTransport;
//# sourceMappingURL=ESTransport.js.map


//////////////////
// WEBPACK FOOTER
// ./~/searchkit/lib/src/core/transport/ESTransport.js
// module id = 136
// module chunks = 0